module.exports = {"yytx18":{"daobanList":[{"title":"1:是否办理（新）广州市老年人优待卡的核发（户籍及常住外埠老年人办理）","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、一寸免冠白底彩色相片","state":"必要"},{"name":"2、港澳台居住证","state":"必要"},{"name":"3、台湾居民居住证","state":"必要"},{"name":"4、居民身份证","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx18.json
// module id = 1317
// module chunks = 0